import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import PageHeader, { PageBody, Card, Badge, useFetch } from "../components/Shared";

const STATUS_TONE = { NEW: "signal", ASSIGNED: "warning", IN_PROGRESS: "warning", WAITING: "neutral", RESOLVED: "forest" };

export default function Escalations() {
  const [status, setStatus] = useState("");
  const { data, loading } = useFetch(
    () => api.get("/human-inbox/conversations", { params: status ? { status } : {} }).then((r) => r.data),
    [status]
  );
  const items = data?.items || [];

  return (
    <>
      <PageHeader label="Inteligencia Conversacional" title="Escalamientos"
        description="Conversaciones que el sistema detectó que requieren (o requirieron) atención humana.">
        <select data-testid="esc-status-filter" value={status} onChange={(e) => setStatus(e.target.value)}
          className="bg-white border border-carbon-200 rounded px-3 py-2 text-sm">
          <option value="">Activos</option>
          <option value="RESOLVED">Resueltos</option>
        </select>
      </PageHeader>
      <PageBody>
        {loading ? <div className="text-carbon-500">Cargando...</div> : items.length === 0 ? (
          <Card className="p-10 text-center text-carbon-500">Sin escalamientos.</Card>
        ) : (
          <Card className="overflow-hidden" testid="esc-table">
            <table className="w-full text-sm">
              <thead className="bg-page text-[10px] uppercase tracking-wider text-carbon-400">
                <tr>
                  <th className="text-left px-4 py-2">Usuario</th>
                  <th className="text-left px-4 py-2">Motivo</th>
                  <th className="text-left px-4 py-2">Score</th>
                  <th className="text-left px-4 py-2">Trigger</th>
                  <th className="text-left px-4 py-2">Asignado</th>
                  <th className="text-left px-4 py-2">Estado</th>
                  <th className="px-4 py-2"></th>
                </tr>
              </thead>
              <tbody>
                {items.map((c) => {
                  const e = c.escalation || {};
                  return (
                    <tr key={c.id} className="border-t border-carbon-100" data-testid={`esc-row-${c.id}`}>
                      <td className="px-4 py-2">{c.user?.name || c.user?.whatsapp || "—"}</td>
                      <td className="px-4 py-2 max-w-xs truncate text-carbon-600">{e.reason || "—"}</td>
                      <td className="px-4 py-2 font-mono">{e.score ?? "—"}</td>
                      <td className="px-4 py-2 text-xs">{e.trigger || "—"}</td>
                      <td className="px-4 py-2 text-xs">{c.assigned_agent_name || "—"}</td>
                      <td className="px-4 py-2"><Badge tone={STATUS_TONE[c.human_status] || "neutral"}>{(c.human_status || "").replace("_", " ")}</Badge></td>
                      <td className="px-4 py-2 text-right"><Link to="/supervisor/inbox" className="text-terracotta text-xs">Abrir →</Link></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Card>
        )}
      </PageBody>
    </>
  );
}
